import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { createPreviewApi } from './previewWrapper';
import { PreviewApiKey } from './publicApiKey';

export {
  PREVIEW_HORIZONTAL_MARGIN,
  TABLET_MIN_WIDTH,
  TABLET_WIDTH,
  TABLET_LAPTOP_WIDTH,
  DESKTOP_WIDTH,
  WIDE_DESKTOP_WIDTH,
  BREAKPOINT_DELTA,
  COMMONLY_LARGE_LAPTOP,
  COMMONLY_SMALL_TABLET,
  MOBILE_MAX_RANGE,
  MOBILE_MIN_RANGE,
  MOBILE_CANVAS_SIZE,
  DESKTOP_CANVAS_SIZE,
  LARGE_SCREEN_SIZE,
} from './constants';

export const PreviewEntrypoint: EntryPoint = {
  name: 'PreviewApi',
  declareAPIs: () => [PreviewApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(PreviewApiKey, () => createPreviewApi(shell));
  },
};
